import React from 'react';
import { ArrowRight, CheckCircle, Shield, Clock, FileText } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    'РВП, ВНЖ, Гражданство РФ',
    'Переводы документов',
    'Полный комплекс услуг',
    'Работаем в Москве и МО'
  ];

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
        <div className="hero-glow"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text fade-in-left">
            <h1 className="hero-title">
              Профессиональная помощь
              <span className="text-gradient"> в решении миграционных вопросов</span>
            </h1>

            <p className="hero-description">
              РВП, ВНЖ, Гражданство РФ, Переводы — Полный комплекс услуг в
              Москве и Московской области
            </p>

            <div className="hero-features">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="hero-feature"
                  style={{ animationDelay: `${index * 0.1 + 0.3}s` }}
                >
                  <div className="feature-icon-wrapper">
                    <CheckCircle size={20} className="feature-icon" />
                  </div>
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="hero-buttons">
              <button className="btn-primary" onClick={scrollToForm}>
                <span>Оставить заявку</span>
                <ArrowRight size={20} className="btn-icon" />
                <div className="btn-glow"></div>
              </button>

              <a href="#services" className="btn-secondary">
                Наши услуги
              </a>
            </div>
          </div>

          <div className="hero-visual fade-in-right">
            <div className="glass-card main-card float">
              <div className="card-header">
                <Shield className="card-icon text-gradient" size={32} />
                <h3>Сопровождение документов</h3>
              </div>
              <p>Поддержка на всех этапах подготовки и подачи документов</p>
              <div className="card-glass-effect"></div>
            </div>

            <div className="glass-card sub-card float-delayed-1">
              <Clock size={24} className="card-icon text-gradient" />
              <div>
                <strong>Экономия времени</strong>
                <span>Берем бюрократию на себя</span>
              </div>
            </div>

            <div className="glass-card sub-card-2 float-delayed-2">
              <FileText size={24} className="card-icon text-gradient" />
              <div>
                <strong>Правильные документы</strong>
                <span>Без ошибок и очередей</span>
              </div>
            </div>

            <div className="blur-orb orb-1"></div>
            <div className="blur-orb orb-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;